<template>
    <div class="modal fade show d-block" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
            <div class="modal-content" style="width: 100%">
                <div class="modal-header">
                    <h5 class="modal-title">{{ $t('export') }} — {{ table.name }}</h5>
                    <button type="button" class="btn-close" @click="$emit('close')"></button>
                </div>
                <div class="modal-body">
                    <div v-if="substringedDuplicates.length" class="alert alert-danger">
                        <div class="fw-bold mb-1">{{ $t('duplicateColumns') }}</div>
                        <div class="small mb-2">{{ $t('duplicateColumnsDescription') }}</div>
                        <div class="small fw-semibold">{{ substringedDuplicates.join(', ') }}</div>
                    </div>

                    <template v-else>
                        <div v-if="truncatedColumns.length" class="alert alert-warning">
                            <div class="fw-bold mb-1">{{ $t('columnsWillBeTruncated') }}</div>
                            <div class="small">{{ truncatedColumns.join(', ') }}</div>
                        </div>

                        <div class="row g-2 mb-3">
                            <div class="col-md-4">
                                <label class="form-label small fw-bold">{{ $t('idColumn') }}</label>
                                <select class="form-select form-select-sm" v-model="dataId">
                                    <option v-for="c in dataColumns" :key="c.name" :value="c.name">{{ c.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label small fw-bold">{{ $t('fromColumn') }}</label>
                                <select class="form-select form-select-sm" v-model="dataFrom">
                                    <option v-for="c in dataColumns" :key="c.name" :value="c.name">{{ c.name }}</option>
                                </select>
                            </div>
                            <div class="col-md-4">
                                <label class="form-label small fw-bold">{{ $t('toColumn') }}</label>
                                <select class="form-select form-select-sm" v-model="dataTo">
                                    <option v-for="c in dataColumns" :key="c.name" :value="c.name">{{ c.name }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="mb-3">
                            <label class="form-label small fw-bold">{{ $t('geometryTable') }}</label>
                            <select class="form-select form-select-sm" v-model="geoTable" @change="loadGeoColumns">
                                <option :value="null">{{ $t('noGeometry') }}</option>
                                <option v-for="t in geoTables" :key="t.name" :value="t.name">{{ t.name }}</option>
                            </select>
                        </div>

                        <div v-if="geoTable" class="mb-3">
                            <label class="form-label small fw-bold">{{ $t('geometryIdColumn') }}</label>
                            <select class="form-select form-select-sm" v-model="geoId">
                                <option v-for="c in geoColumns" :key="c.name" :value="c.name">{{ c.name }}</option>
                            </select>
                        </div>

                        <div v-if="errorMessage" class="alert alert-danger py-2 mt-3">{{ errorMessage }}</div>
                    </template>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" @click="$emit('close')">{{ $t('cancel') }}</button>
                    <button type="button" class="btn btn-primary" @click="submitExport" :disabled="!valid">{{ $t('export') }}</button>
                </div>
            </div>
        </div>
    </div>
    <div class="modal-backdrop fade show"></div>
</template>

<script>
    import dataspaceApi from '../../api/server/dataspace';

    export default {
        name: 'ExportModal',
        props: ['table', 'dataSpaceId'],
        data() {
            return {
                geoTables: [],
                geoColumns: [],
                geoTable: null,
                geoId: '',
                geoColumn: '_geo_',
                dataId: '',
                dataFrom: '',
                dataTo: '',
                errorMessage: ''
            };
        },
        computed: {
            dataColumns() {
                return (this.table.columns || []).filter(c => c.name.toLowerCase() !== '_geo_');
            },
            truncatedColumns() {
                return this.dataColumns.filter(c => c.name.length > 11).map(c => c.name);
            },
            substringedDuplicates() {
                var seen = {};
                var dupes = [];

                this.dataColumns.forEach(c => {
                    var substringedName = c.name.substring(0, 11).toLowerCase();

                    if (seen[substringedName]) {
                        if (!dupes.includes(seen[substringedName]))
                            dupes.push(seen[substringedName]);

                        dupes.push(c.name);
                    } else {
                        seen[substringedName] = c.name;
                    }
                });

                return dupes;
            },
            valid() {
                if (this.substringedDuplicates.length) return false;
                if (!this.geoTable) return true;
                return this.dataId && this.dataFrom && this.dataTo && this.geoId && this.geoColumn;
            }
        },
        async mounted() {
            const all = await dataspaceApi.tables(this.dataSpaceId);
            this.geoTables = all.filter(t => 
                //t.origin === 'SHP'
                (t.columns || []).some(c => c.name.toLowerCase() === '_geo_')
            );
        },
        methods: {
            async loadGeoColumns() {
                if (!this.geoTable) {
                    this.geoColumns = [];
                    return;
                }
                const t = this.geoTables.find(x => x.name === this.geoTable);
                this.geoColumns = (t.columns || []).filter(c => c.name.toLowerCase() !== '_geo_');
            },
            submitExport() {
                const params = new URLSearchParams();
                if (this.geoTable) {
                    params.append('geoTable', this.geoTable);
                    params.append('geoId', this.geoId);
                    params.append('geoColumn', this.geoColumn);
                    params.append('dataId', this.dataId);
                    params.append('dataFrom', this.dataFrom);
                    params.append('dataTo', this.dataTo);
                }
                var request = dataspaceApi.tableShpExport(this.dataSpaceId, this.table.name, params.toString())
                window.open(request.url);
                
                this.$emit('close');
            }
        }
    };
</script>
